import { useCallback, useEffect, useRef, useState } from "react";
import { useAcademicYear } from "../contexts/AcademicYearContext";

/**
 * Local academic-year filter that defaults to the app's current year once loaded.
 * Avoids sticking on the context fallback before app_settings is fetched.
 */
export function useSelectedAcademicYear() {
	const { currentAcademicYear, loading } = useAcademicYear();
	const [selectedAcademicYear, setSelectedAcademicYearState] = useState("");
	const userPickedRef = useRef(false);

	useEffect(() => {
		if (loading || !currentAcademicYear || userPickedRef.current) return;
		setSelectedAcademicYearState(currentAcademicYear);
	}, [currentAcademicYear, loading]);

	const setSelectedAcademicYear = useCallback((value) => {
		userPickedRef.current = true;
		setSelectedAcademicYearState(value);
	}, []);

	return {
		selectedAcademicYear: selectedAcademicYear || currentAcademicYear || "",
		setSelectedAcademicYear,
		currentAcademicYear,
		academicYearLoading: loading,
	};
}
